import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Headline from 'components/Headline/Headline';
import Loader from 'components/Loader/Loader';
import ActivateToggle from 'components/ActivateToggle/ActivateToggle';
import { KeyValueDTO } from 'generated/models/KeyValueDTO';
import { KeyValueStoreService } from 'generated/services/KeyValueStoreService';

const ToggleShowShopping = () => {
  // TODO take from kvstore Redux
  const [showShopping, setShowShopping] = useState<boolean | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(['translation', 'settings']);

  const getValue = async (): Promise<boolean> => {
    const keyValueDto = await KeyValueStoreService.getKeyValueStoreItem(
      KeyValueDTO.key.JCP_SHOW_SHOPPING,
    );

    return keyValueDto.value === 'true';
  };

  const setValue = async (): Promise<void> => {
    setLoading(true);

    const keyValueDto = await KeyValueStoreService.setKeyValueStoreItem({
      key: KeyValueDTO.key.JCP_SHOW_SHOPPING,
      value: showShopping ? 'false' : 'true',
    });

    setLoading(false);

    setShowShopping(keyValueDto.value === 'true');
  };

  useEffect(() => {
    getValue().then((_showShopping) => setShowShopping(_showShopping));
  }, []);

  return (
    <div>
      <Headline className="settings__headline" headingLevel="h2" size={2}>
        {t('settings:toggle-show-shopping.headline')}
      </Headline>

      <p className="settings__block page__form-desc">
        {t('settings:toggle-show-shopping.description')}
      </p>

      {showShopping === undefined ? (
        <Loader />
      ) : (
        <div>
          <label id="statistic-shopping-toggle-desc" className="input__label">
            {t('edit')}
          </label>

          <ActivateToggle
            active={showShopping}
            onToggle={setValue}
            ariaDescribedBy="#statistic-shopping-toggle-desc"
            loading={loading}
            activeIcon="eye"
            inactiveIcon="eye-off"
          />
        </div>
      )}
    </div>
  );
};

export default ToggleShowShopping;
